import { type ReactNode } from "react";

import { type SortValue } from "@/app/lib/types/types";
import { ListToggleButton } from "./ListToggleButton";

type Props<T extends string> = {
  value: SortValue<T>;
  onChange: (value: SortValue<T>) => void;
  children: ReactNode;
  isSelected: boolean;
};

export function SortButton<T extends string>({
  value,
  onChange,
  isSelected,
  children,
}: Props<T>) {
  return (
    <ListToggleButton
      onChange={() => onChange(value)}
      selected={isSelected}
      value={`${value.field}_${value.order}`}
    >
      {children}
    </ListToggleButton>
  );
}
